import { useCallback, useEffect, useMemo, useRef } from "react";

export function useBroadcastChannel<T>(name: string, onMessageReceived?: (event: MessageEvent<T>) => void) {
  const channel: BroadcastChannel = useMemo(() => {
    return new BroadcastChannel(name);
  }, [name]);

  const isSubscribed = useRef(false);

  useEffect(() => {
    if (!isSubscribed.current) {
      channel.onmessage = (event: MessageEvent<T>) => {
        if (onMessageReceived) onMessageReceived(event);
      };
    }
    return () => {
      if (isSubscribed.current) {
        channel.close();
        isSubscribed.current = true;
      }
    };
  }, [channel, onMessageReceived]);

  const postMessage = useCallback(
    (message: T) => {
      channel.postMessage(message);
    },
    [channel]
  );

  return {
    postMessage,
  };
}
